import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { CabinExperiencesComponent } from './cabin-experiences.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, ModalModule.forRoot()],
  declarations: [CabinExperiencesComponent],
  exports: [CabinExperiencesComponent]
})
export class CabinExperiencesModule {}
